import React from "react";
import { useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import { selectMilestoneLabels } from "../../../store/slices/projectSlice";
import SidebarScroll from "./SidebarScroll";
import SidebarCollapseButton from "./SidebarCollapseButton";

export default function Milestones() {
  const milestones = useSelector(selectMilestoneLabels);
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-start">
        <h5 className="card-title">Milestones</h5>
        <HelpButton helpKey="milestones" />
        <SidebarCollapseButton
          collapsed={collapsed}
          onClick={() => setCollapsed((value) => !value)}
        />
      </div>
      {!collapsed && (
        <div className="card-body p-0">
          {milestones.length > 0 ? (
            <SidebarScroll>
              <ul className="list-group list-group-flush">
                {milestones.map((milestone) => (
                  <li
                    key={milestone}
                    className="list-group-item p-2 d-flex justify-content-between align-items-center"
                  >
                    <span>{milestone}</span>
                    <UsedInBadge arg={{ UUID: milestone }} />
                  </li>
                ))}
              </ul>
            </SidebarScroll>
          ) : (
            <div className="text-center m-1">No milestones</div>
          )}
        </div>
      )}
    </div>
  );
}
